import { Component, Prop, Watch } from "vue-property-decorator";
import baseUserContexetProductComponent from "@/components/baseUserContextProductComponent";
import Vue from "vue";
import { productModel } from "@/models/productModel";

@Component({})
export default class CarouselProduct extends baseUserContexetProductComponent {
    @Prop({ default: () => [] })
    items: [];
    @Prop({ default: () => false })
    isLoadingRelations: boolean;

    onSelectProduct(p: productModel) {
        this.$emit("onCarouselSelectProduct", p);
    }

    get responsiveOptions() {
        return [
            {
                breakpoint: "1380px",
                numVisible: 4,
                numScroll: 4
            },
            {
                breakpoint: "1190px",
                numVisible: 3,
                numScroll: 3
            },
            {
                breakpoint: "920px",
                numVisible: 2,
                numScroll: 2
            },
            {
                breakpoint: "600px",
                numVisible: 1,
                numScroll: 1
            }
        ];
    }
}